import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import LoadingIconFull from '~/Common-Objects/LoadingIcons/loadingIconFull'
import helpers from '~/Classes/helpers'

export function isMailchimpConvertingTemplate(template) {
    return !!(template && template.templateJson && template.templateJson.mailchimpConverting)
}

export function mailchimpEditorPath(template, accountMaster) {
    const id = template.id
    const type = Number(template.templateType)
    const useV2 =
        !!(accountMaster && accountMaster.options && accountMaster.options.useEditorV2) ||
        helpers.checkTemplateEditorVersionAccountDate(accountMaster)
    if (type === 0) {
        return (useV2 ? '/cp/templates/add/dragDropv2/' : '/cp/templates/add/dragDrop/') + id
    }
    if (type === 2) {
        return '/cp/templates/add/wysiwyg/' + id
    }
    return '/cp/templates/add/fromCode/' + id
}

/**
 * Shown while a Mailchimp template stub is still being converted to drag-and-drop.
 * @param {{ templateId: number|string, history: object, onReady?: Function }} props
 */
export default function MailchimpTemplateConverting({ templateId, history, onReady }) {
    const accountMaster = useSelector((state) => state.accountMaster.accountMaster)

    useEffect(() => {
        let stopped = false

        const poll = async () => {
            try {
                const res = await axios.get('/template/' + templateId)
                const template = res.data && res.data.template
                if (!template || isMailchimpConvertingTemplate(template) || stopped) return
                stopped = true
                const path = mailchimpEditorPath(template, accountMaster)
                const search = (history.location && history.location.search) || ''
                const pathname = history.location && history.location.pathname
                if (pathname !== path) {
                    history.replace(path + search)
                    return
                }
                if (onReady) onReady(template)
            } catch (err) {
                // Keep the converting screen up and try again on the next poll.
            }
        }

        poll()
        const timer = window.setInterval(poll, 3000)
        return () => {
            stopped = true
            window.clearInterval(timer)
        }
    }, [templateId, history, accountMaster, onReady])

    return (
        <LoadingIconFull
            changingText={[i18n.t('mailchimp2:converting.status')]}
            bottomText={i18n.t('mailchimp2:converting.hint')}
        />
    )
}
